import { render, staticRenderFns } from "./drProjectRegisterKaiYeTest.vue?vue&type=template&id=22daa86d&scoped=true"
import script from "./drProjectRegisterKaiYeTest.vue?vue&type=script&lang=js"
export * from "./drProjectRegisterKaiYeTest.vue?vue&type=script&lang=js"
import style0 from "./drProjectRegisterKaiYeTest.vue?vue&type=style&index=0&id=22daa86d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22daa86d",
  null
  
)

export default component.exports